import '@fontsource-variable/readex-pro';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setUpApp } from './lib/app';
import './i18n';
import './styles.css';

setUpApp();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
